import { Component } from '@angular/core';

@Component({
    selector: 'app-kb-software-confirmation-page',
    template: `<h2 class="my-4  font-color-blue">{{'common.text_software_thank_for_request_lable_na'|cxTranslate}}</h2>
  <P class="fs-18 mb-0">{{'common.text_software_search_type_code_content1_na'|cxTranslate}}</P>
  <hr>
  <div class="my-2 d-flex align-items-center justify-content-center"><button [routerLink]="'/'"
          class="btn btn-blue">{{'common.text_software_return_homepage_lable'|cxTranslate}}</button>
  </div>`,
    styles: [
        `.font-color-blue {
      color: var(--kb-blue);
      font-weight: 700;
      font-size: 24px !important;
  }

  .fs-18 {
      font-size: 18px !important;
  }

  .btn-blue {
      background-color: #00457e !important;
      border-color: #00457e !important;
      color: var(--normal-white);
      font-size: 20px !important;
      text-transform: none;

      &:hover {
          background-color: #c4ccd7 !important;
          border-color: #c4ccd7 !important;
          color: #5b5b5b !important;
      }
  }`
    ],
    standalone: false
})
export class KbSoftwareConfirmationPageComponent {

}
